import { Search } from "lucide-react";

interface CampoPesquisaProps {
  valor: string;
  onChange: (valor: string) => void;
  placeholder: string;
  /** Rótulo acessível — o campo não tem rótulo visível, só o placeholder. */
  rotulo: string;
  className?: string;
}

/**
 * Campo de pesquisa das listas (mesmo visual dos campos de pesquisa de
 * Usuários e Ministérios). Só cuida da entrada: quem usa decide como filtrar
 * (ver `normalizarBusca` em `@/shared/lib/busca`).
 */
export function CampoPesquisa({
  valor,
  onChange,
  placeholder,
  rotulo,
  className = "",
}: CampoPesquisaProps) {
  return (
    <div className={`relative ${className}`}>
      <Search
        size={16}
        aria-hidden="true"
        className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-muted"
      />
      <input
        type="search"
        value={valor}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={rotulo}
        autoComplete="off"
        className="w-full rounded-xl border border-border bg-surface py-3 pl-11 pr-4 text-sm text-text placeholder:text-muted focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
      />
    </div>
  );
}
